





















import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class SearchTimelineEntryComponent extends Vue {
  s: string | null = "";

  @Watch("$route.query.search")
  onSearchChanged(): void {
    if (this.$route.query.search) {
      this.s = this.$route.query.search as string;
    }
  }

  created() {
    if (this.$route.query.search) {
      this.s = this.$route.query.search as string;
    }
  }

  onSearch(): void {
    const p = Object.assign({}, this.$route.query, {
      search: this.s
    });
    this.$router.push({ query: p }).catch(() => {
      return;
    });
  }

  onClear(): void {
    const p = Object.assign({}, this.$route.query, {
      search: ""
    });
    this.$router.push({ query: p }).catch(() => {
      return;
    });
  }
}
